import React from 'react'

const BusyLoader = () => {
    return (
        <div className='w-full'>
            <div className='h-1 w-full bg-slate-200 dark:bg-slate-900 overflow-hidden'>
                <div className='animate-progress w-full h-full bg-primary text-primary-foreground origin-left-right'></div>
            </div>
        </div>
    )
}

export default BusyLoader